import  iconeAcessorio  from '@/assets/iconesEtapas/icone-acessorio.png'
import  iconeAvaria  from '@/assets/iconesEtapas/icone-avaria.png'
import  iconeCombustivel  from '@/assets/iconesEtapas/icone-combustivel.png'
import  iconeFormulario  from '@/assets/iconesEtapas/icone-formulario.png'
import  iconeFoto  from '@/assets/iconesEtapas/icone-foto.png'
import  iconePneus  from '@/assets/iconesEtapas/icone-pneus.png'

export default class EtapasComponentesConstant {
    static ETAPAS = {
        acessorio: {
            descricao: 'Acessórios',
            icone: iconeAcessorio
        },
        avaria: {
            descricao: 'Avarias',
            icone: iconeAvaria
        },
        combustivel: {
            descricao: 'Combustível',
            icone: iconeCombustivel
        },
        formulario: {
            descricao: 'Formulário',
            icone: iconeFormulario
        },
        foto: {
            descricao: 'Fotos',
            icone: iconeFoto
        },
        estadoPneu: {
            descricao: 'Pneus',
            icone: iconePneus
        }
    }
}